export const vesselsName = {
      "SM80000523000303": { unitId: "SM80000523000303", name: "VN-00001" },
      "SM80000523000114": { unitId: "SM80000523000114", name: "VN-00002" },
      "SM80000523000331": { unitId: "SM80000523000331", name: "VN-00003" },
      "SM80000523000315": { unitId: "SM80000523000315", name: "VN-00004" },
      "SM80000523000312": { unitId: "SM80000523000312", name: "VN-00005" },
      "SM80000523000317": { unitId: "SM80000523000317", name: "VN-00006" },
      "SM80000523000334": { unitId: "SM80000523000334", name: "VN-00007" },
      "SM80000523000310": { unitId: "SM80000523000310", name: "VN-00008" },
      "SM80000725300007": { unitId: "SM80000725300007", name: "VN-00009" },
      "SM80000523000307": { unitId: "SM80000523000307", name: "VN-00010" },
      "SM80000725300023": { unitId: "SM80000725300023", name: "VN-00011" },
      "SM80000523000316": { unitId: "SM80000523000316", name: "VN-00012" },
      "SM80000725300031": { unitId: "SM80000725300031", name: "VN-00013" },
      "SM80000523000341": { unitId: "SM80000523000341", name: "VN-00014" },
      "SM80000523000321": { unitId: "SM80000523000321", name: "VN-00015" },
      "SM80000725300019": { unitId: "SM80000725300019", name: "VN-00016" },
      "SM80000725300037": { unitId: "SM80000725300037", name: "VN-00017" },
      "SM80000725300020": { unitId: "SM80000725300020", name: "VN-00018" },
      "SM80000725300013": { unitId: "SM80000725300013", name: "VN-00019" },
      "SM80000725300018": { unitId: "SM80000725300018", name: "VN-00020" }
    };
export const vesselColor = {
  1: 'blue-vessel',
  2: 'red-vessel',
  3: 'green-vessel',
  4: 'yellow-vessel',
  5: 'gray-vessel',
  6: 'black-vessel',
};